import { render, staticRenderFns } from "./ProductMetadata.vue?vue&type=template&id=5103e7d2&"
import script from "./ProductMetadata.vue?vue&type=script&lang=ts&"
export * from "./ProductMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports